var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAts(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    stroke: "white",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49935 18.8337H12.4993C16.666 18.8337 18.3327 17.167 18.3327 13.0003V8.00033C18.3327 3.83366 16.666 2.16699 12.4993 2.16699H7.49935C3.33268 2.16699 1.66602 3.83366 1.66602 8.00033V13.0003C1.66602 17.167 3.33268 18.8337 7.49935 18.8337Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9746 15.916V12.666",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9746 6.70801V5.08301",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9733 11.0413C14.1699 11.0413 15.14 10.0713 15.14 8.87467C15.14 7.67806 14.1699 6.70801 12.9733 6.70801C11.7767 6.70801 10.8066 7.67806 10.8066 8.87467C10.8066 10.0713 11.7767 11.0413 12.9733 11.0413Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02539 15.917V14.292",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02539 8.33301V5.08301",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.02409 14.2913C8.22071 14.2913 9.19075 13.3213 9.19075 12.1247C9.19075 10.9281 8.22071 9.95801 7.02409 9.95801C5.82747 9.95801 4.85742 10.9281 4.85742 12.1247C4.85742 13.3213 5.82747 14.2913 7.02409 14.2913Z",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAts);
export default __webpack_public_path__ + "static/media/ats.c6c39239b76645e0524bfd2ec9eeefc4.svg";
export { ForwardRef as ReactComponent };